<template>
  <div class="container almost-done">
    <div class="row pt-5">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t("almostDone.title")}}
        </label>
      </div>
    </div>
    <div class="row pt-5 pb-4">
      <div class="col-12 offset-md-4 col-md-4 text-center">
        <img class="img-question" src="../assets/thank_you.svg" alt="thank-you">
      </div>
    </div>
    <div class="row pt-5">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="next">
          {{ $t('almostDone.continue') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    next () {
      this.$router.push({
        name: 'education'
      })
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'almostdone')
  }
}
</script>

<style>
.almost-done .title {
  font-weight: 700;
  font-size: 1.6rem;
}

.almost-done .img-question {
  width: 100%;
  height: 34vh;
}

.almost-done .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

@media screen and (device-aspect-ratio: 40/71) {
  .almost-done .title {
    font-size: 1.4rem;
  }

  .almost-done .img-question {
    width: 100%;
    height: 24vh;
  }

  .almost-done .next {
    min-height: 70px;
  }
}
</style>
